
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b58"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b58"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hqokU", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $caf7be09e81127c6$export$6503ec6e8aabbaf; }, function (v) { return $caf7be09e81127c6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $caf7be09e81127c6$export$f7ad0328861e2f03; }, function (v) { return $caf7be09e81127c6$export$f7ad0328861e2f03 = v; });
var $caf7be09e81127c6$export$6503ec6e8aabbaf;
var $caf7be09e81127c6$export$f7ad0328861e2f03;
"use strict";
var $caf7be09e81127c6$var$mapping = new Map();
function $caf7be09e81127c6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$caf7be09e81127c6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $caf7be09e81127c6$var$resolve(id) {
    var resolved = $caf7be09e81127c6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$caf7be09e81127c6$export$6503ec6e8aabbaf = $caf7be09e81127c6$var$register;
$caf7be09e81127c6$export$f7ad0328861e2f03 = $caf7be09e81127c6$var$resolve;

});

var $65d1d8e399b561e1$exports = {};

(parcelRequire("hqokU")).register(new URL("", import.meta.url).toString(), JSON.parse('["8HV7b","index.f4a89e38.js","dRb5C","ccip.51a052d3.js","bwvhT","Wave.2a680c9e.svg","jhKSN","Wave2.22db6b94.svg","kG6eE","Wave3.ea6ec40e.svg","jGeXC","dist.8aef4ca8.js","69Bpw","dist.3f7e1f5e.js","2d68P","dist.2b0fde13.js","bQSay","index.es.5ea190e0.js","fah7H","dist.7c38f7c6.js","cvh18","dist.ea0b1bc2.js","6Ctxx","ArbitrumLogo.4a7518b6.svg","iYysj","AvalancheLogo.ad53a0d0.svg","58ee8","BaseLogo.e87313d9.svg","gEmSb","BAT.1212afba.svg","k0tIo","BNBLogo.3dada3dc.svg","4kJmp","BTCLogo.5558c6c7.svg","7KHUv","BUSDLogo.a70524b3.svg","eqwas","CardanoLogo.c8e54c54.svg","e96oS","DashLogo.ac107e85.svg","k6oI4","Doge.9d700487.png","4X9X6","DogeLogo.58faeab6.svg","iItNz","DOT.7e599be5.svg","3VEfT","EthLogo.b15259c3.svg","8bibN","LitecoinLogo.f8fad246.svg","2WdTm","PolygonLogo.7d5d4b87.svg","i2THl","Solana.47b69164.svg","cXIcQ","TetherLogo.85e85692.svg","dy3ac","TronLogo.a023c6a9.svg","96RvE","USDCLogo.08b3a902.svg","8ADjM","EURCLogo.3ca41448.svg","cREYt","VerseLogo.e24b56c2.png","1o9dH","XMRLogo.26608d9e.svg","ll0GF","ZcashLogo.5ee68c2f.svg","1QiyQ","EUROLogo.d27285e3.svg","EjZ3g","GBPLogo.18d6f7a0.svg","fY7ey","BCHLogo.b63c073e.svg","k2FRC","esm.893c96b7.js","8PVfM","esm.6a04bb0b.js","1RLh6","FRAXLogo.493412e4.svg","1qZNw","DaiLogo.5b7d885d.svg","fxoJv","WETH.6226dbd9.svg","b7vDy","GeminiLogo.5cbba47e.png","iFf9P","TORLogo.bd732ad4.svg","6qkpd","TUSDLogo.df934baa.svg","hz1T3","USDPLogo.d2d050af.svg","aGdoK","TetherGoldLogo.5d02ace7.svg","3eM0U","PRQLogo.ef7c079b.svg","4Enq5","PAXGLogo.814ce36e.svg","kEJ5D","MIMLogo.ea9454b3.svg","8OztN","FantomLogo.59ea410b.svg","kr6xt","WrappedBitcoin.a9abc558.svg","7HCPR","DAIKLogo.7aa105ad.png","iIP2Y","ETHKLogo.b79115fc.png","55VBg","BTCKLogo.9770427e.png","bPvY1","WOKTLogo.2376971f.png","auQvF","OKBLogo.8b0e77b3.png","e3EY9","de_3.a3625524.png","iYXo1","nl_3.d58cedc9.png","lOhRA","fr_3.5245a318.png","fglhc","es_3.ad2f5d9f.png","kcR0C","pt_3.7cd5ed24.png","kAjaI","pl_3.71278cad.png","g0fA5","sk_3.356463f5.png","iBIuu","uk_3.f58a4276.png","iL7cS","AuroraLogo.5103bfbf.svg","3848X","MetisLogo.a52a09ed.svg","cOAcB","OptimismLogo.4bfae879.svg","49zkW","RadomLogo.e62d1930.svg","1t87D","ScrollLogo.6da344f7.svg","hlVXB","OKXLogo.c4036e07.png"]'));


//# sourceMappingURL=index.runtime.2c3f5cb1.js.map
